import { createFileRoute } from "@tanstack/react-router";
import { requireReachableRoute } from "@/lib/offline/routeGuard";

// Section layout guard: feasibility is online-only by design (analytical desk
// work). Covers every child route via ancestor stance resolution.
export const Route = createFileRoute("/_auth/app/_app/org/$orgId/feasibility")({
	staticData: { offline: "online-only" },
	beforeLoad: () => requireReachableRoute("online-only"),
});
